<template>
  <div id="listModal">
    <div class="modal fade addToList" id="addToList" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header border-0">
            <div class="modal-title w-100 CartSaveSingleModal d-flex">
              <div class="flex-fill h4 mb-0">
                {{ $translate("CartSave::Template.cartModalHeader") }}
              </div>
              <button type="button" class="close" ref="closeBtn" data-dismiss="modal"  aria-hidden="true">&times;</button>
            </div>
          </div>
          <div class="modal-body">
            <ul role="tablist" class="nav nav-tabs d-flex mt-2">
              <li role="tab" class="nav-item flex-fill" >
                <a data-toggle="tab" href="#cartList" class="text-appearance d-block border AddToListTab active p-3">{{ $translate("CartSave::Template.addToListMyCarts") }}</a>
              </li>
              <li role="tab" class="nav-item flex-fill ">
                <a data-toggle="tab" href="#cartCreate" class="text-appearance d-block border AddToListTab p-3">{{ $translate("CartSave::Template.addToListNewCart") }}</a>
              </li>
            </ul>
            <div class="tab-content">
              <div role="tabpanel" class="tab-pane active" id="cartList">
                <div class="grey-bg p-3">
                  <cs-list :carts="carts"></cs-list>
                </div>
              </div>
              <div role="tabpanel" class="tab-pane" id="cartCreate">
                <div class="grey-bg py-3">
                  <div class="col-12">
                    <div class="input-unit">
                      <input id="cartName"  v-model="cartName" @keydown.enter.prevent="createCart()">
                      <label for="cartName">{{ $translate("CartSave::Template.cartCartName") }}</label>
                    </div>
                  </div>
                  <div class="row justify-content-center">
                    <button class="btn btn-primary " @click="createCart()">
                      {{  $translate("CartSave::Template.addToListCreateCart") }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";
import loadCartsaveStore from "../mixins/loadCartsaveStore"
import csList from "./csList.vue"

export default
{
  name: "csModal",
  mixins:[loadCartsaveStore],
  data () {
    return {
      isLoading : false,
      cartName:'',
    }
  },
  components:{csList},
  mounted()
  {
    if (!App.isShopBuilder)
    {
      const _self = this
      $.when(
          this.loading = true,
          this.load(),
      ).done(function ()
      {
        _self.isLoading = false
      })
    }
    else
    {
      this.isLoading = false
    }
  },
  methods:
  {
    load ()
    {
      return this.$store.dispatch('loadCarts')
    },
    createCart()
    {
      let _self     = this;
      let createdAt = new Date().toLocaleDateString();
      let vars      = [];
      if(Object.keys(this.item).length > 0)
      {
        vars.push({'id':this.item.id,"quantity":this.item.quantity})
      }
      if(Object.keys(this.items).length > 0)
      {
        for(let i = 0; i < this.items.length; i++)
        {
          vars.push({'id':this.items[i].id,"quantity":this.items[i].quantity})
        }
      }
      let cart =
      {
        cartName        : this.cartName,
        cartPublic      : 0,
        cartUpdatedAt   : createdAt,
        cartCreatedAt   : createdAt,
        variations      : vars,
      }
      $.ajax({
        type: 'POST',
        url: '/rest/cartsave/cart/createCart/',
        data: cart,
        success: function (response)
        {
          let data      = JSON.parse(response);
          data.items    = [];
          data.loading  = false;
          data.url      = '';
          data.waiting  = false;

          _self.$store.commit('addNewCart',data)
          $('#addToList .nav-tabs li:first-child a').tab('show');

        },
        error: function (jqXHR, textStatus, errorThrown)
        {
          CeresNotification.error(ceresTranslate("CartSave::Template.notesWarenkorbNichtErstellt")).closeAfter(3000);
        }
      })
    }
  },
  computed:
  {
    ...mapState({
      carts: state => state.cartsave.carts,
      item:state => state.cartsave.item,
      items:state => state.cartsave.items
    })
  }

}
</script>

